import React, { Component, useContext, useEffect, useState } from "react";
import { Redirect, Link } from "react-router-dom";
import AppContext from "../AppContext";

import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
} from "mdb-react-ui-kit";

import Cookies from "universal-cookie";
const cookies = new Cookies();

function NewsModal(props) {
  const context = useContext(AppContext);
  const [news, setNews] = useState();

  useEffect(() => {
    document.body.style.overflow = "hidden";
    onGetNews();
  }, []);

  const onGetNews = () => {
    context.interAxios.get("/news", function (response) {
      setNews(response.data);
    });
  };

  const closeModal = () => {
    cookies.set(
      "news",
      {
        timestamp: news.createdAt,
      },
      { path: "/" },
    );
    props.hideModal();
  };

  return (
    <>
      <MDBModal staticBackdrop tabIndex="-1" closeOnEsc={false} show={props.visible} className="news-modal">
        <MDBModalDialog size="md">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Újdonságok</MDBModalTitle>
              <MDBBtn className="btn-close" color="none" onClick={closeModal}></MDBBtn>
            </MDBModalHeader>
            {news && (
              <MDBModalBody>
                <div className="news-image">
                  <img src={news.image.url} alt="" />
                </div>
                <div className="news-title">
                  <span>{news.title}</span>
                </div>
                <div className="news-description">
                  <span>{news.description}</span>
                </div>
              </MDBModalBody>
            )}
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </>
  );
}
export default NewsModal;
